import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import image1 from '../images/awaai.jpeg';
import image2 from '../images/awsml.jpeg';
import image3 from '../images/awssap.jpeg';
import image4 from '../images/awssaa.jpeg';

function AwsCertificate() {
  return (
    <div className="my-3">
      <Container>
        <h1 className="fw-bold text-dark text-start">Certifications</h1>
        <hr />
        <Row className="justify-content-center">
          <p className=" col-lg-9  text-center text-dark " >Knowledge/Experience in 150+ AWS Cloud  Services like Financial & Business Management Integrations , Security & Compliance, Storage, Containers, Databases, Network & content Delivery,Customer Enablement & End-user Computing, Web/Mobile Development, Machine Learning, Data Scientist/Analyst, Quantum, BlockChain and so on ......</p> <hr/>
          <Col lg={3} md={6} sm={6} xs={12} className="mb-4 text-center">
            <img className="img-fluid" src={image1} alt="awsai" style={{ filter: 'brightness(100%) ' }} />    <hr /> 
          </Col>
          <Col lg={3} md={6} sm={6} xs={12} className="mb-4 text-center">
            <img className="img-fluid" src={image4} alt="awscert" style={{ filter: 'grayscale(100%)' }} /> 
            <hr /> 
            {/* style={{ filter: 'grayscale(100%)' }} */}
          </Col>
          <Col lg={3} md={6} sm={6} xs={12} className="mb-4 text-center">
            <img className="img-fluid" src={image3} alt="awssap" style={{ filter: 'grayscale(100%)' }}  /> 
            <hr />
             {/* style={{ filter: 'grayscale(100%)' }} */}
          </Col>
          <Col lg={3} md={6} sm={6} xs={12} className="mb-4 text-center">
            <img className="img-fluid" src={image2} alt="awssap" style={{ filter: 'grayscale(100%)' }} />
            <hr />
             {/* style={{ filter: 'grayscale(100%)' }} */}
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default AwsCertificate;